import type { AppProps } from 'next/app';
import { I18nProvider } from 'next-localization';
import { SitecorePageProps } from 'lib/page-props';
import Bootstrap from 'src/Bootstrap';

import '@ahc-digital/component-library/dist/style.css';
import 'assets/main.scss';

import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from 'src/shared/AppInsights.service';

function App({ Component, pageProps }: AppProps<SitecorePageProps>): JSX.Element {
  const { dictionary, ...rest } = pageProps;

  // Disable NextJS route prefetch via env variable
  const router = useRouter();
  useEffect(() => {
    const disablePrefetch = process.env.NEXT_PUBLIC_DISABLE_NEXTJS_PREFETCH;
    if (disablePrefetch === 'true') {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      router.prefetch = async () => {};
    }
  }, [router]);

  return (
    <>
      <AppInsightsContext.Provider value={reactPlugin}>
        <Bootstrap {...pageProps} />
        {/*
        // Use the next-localization (w/ rosetta) library to provide our translation dictionary to the app.
        // Note Next.js does not (currently) provide anything for translation, only i18n routing.
        // If your app is not multilingual, next-localization and references to it can be removed.
      */}
        <I18nProvider lngDict={dictionary} locale={pageProps.locale}>
          <Component {...rest} />
        </I18nProvider>
      </AppInsightsContext.Provider>
    </>
  );
}

export default App;
